import { getValidToken } from '../utils/tokenUtils';

/**
 * Fetches similar Jira ticket suggestions for a single test result.
 * Returns an array of { issueKey, title, score, browseUrl, sameSystem, sameContract }.
 */
export const fetchSimilarTickets = async (testResultId, testExecutionId) => {
  if (!testResultId || !testExecutionId) return [];

  const token = await getValidToken();
  if (!token) throw new Error('Ingen giltig inloggningssession. Logga in på nytt.');

  const params = new URLSearchParams({ testResultId, testExecutionId });

  const res = await fetch(`/api/ai-suggestions/similar-tickets?${params.toString()}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const text = await res.text().catch(() => null);
    const err = new Error(
      `Kunde inte hämta liknande ärenden (${res.status}).` + (text ? ` - ${text}` : '')
    );
    err.status = res.status;
    throw err;
  }

  return res.json();
};
